<template>
    <div
        :class="[
            {
                'tab-item--active': isActive,
            },
            'tab-item',
        ]"
    >
        <span class="tab-item__label">
            {{ t(entry.titleKey) }}
        </span>
    </div>
</template>

<script setup lang="ts">
import { NavigationEntry } from '@/components/navigation/common-navigation'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps<{
    entry: NavigationEntry
}>()

const { t } = useI18n()
const route = useRoute()

const isActive = computed(() =>
    route.matched.some((e) => typeof e.name === 'string' && props.entry.matchRouteNames.includes(e.name)),
)
</script>

<style scoped lang="scss">
.tab-item {
    user-select: none;
    cursor: pointer;

    min-height: 50px;
    font-weight: 400;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0 $spacing-m;
    border-bottom: 1px solid transparent;

    &--active {
        border-bottom: 1px solid $pbl-primary;

        .tab-item__label {
            color: $pbl-primary;
            text-shadow: 0 0 0 currentColor;
        }
    }

    &:hover:not(&--active) {
        color: $pbl-primary;
        border-bottom: 1px solid $pbl-primary;

        @include default-transition;
    }

    &__label {
        display: inline-block;
        white-space: nowrap;
    }
}
</style>
